import styled from "styled-components";
export var SelectFavoriteWithDataContainer = styled.div.withConfig({
  displayName: "styles__SelectFavoriteWithDataContainer",
  componentId: "sc-1mv5k1v-0"
})([""]);